<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      
      <v-flex md12>
        <app-table
          ref="templateTable"
          title="Template"
          :config="config"
          hide-upsert
          @update="update"
        >


         <template slot="headerActions">
            <v-tooltip top>
              <template slot="activator" slot-scope="{ on }">
                <v-btn v-on="on" color="secondary" @click="newEntity()">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>New Template</span>
            </v-tooltip>
          </template>

        </app-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import config from './config_index.js'

export default {
  data () {
    return { config }
  },
  methods: {
    mounted() {
    },
    update(item) {
      this.$router.push("/template/" + item.id);
    },
    newEntity() {
       this.$router.push("/template");
    }
  }
}
</script>
